import React, { useState } from "react";
import Layout from "../../components/layout/Layout/Layout";
import Header from "../../components/layout/Header/Header";
import { formatTitle } from "../../utils/helper";
import Head from "next/head";
import { getCapitalOneBinCheck } from "../../lib/subscriptionRequests";
import { AxiosError } from "axios";
import { useRouter } from "next/router";

const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

interface CapOneFormState {
  loading: boolean;
  error: AxiosError | null;
  redirecting: boolean;
}

export default function CapitalOnePage() {
  const [bin, setBin] = useState<string>("");
  const [formState, setFormState] = useState<CapOneFormState>({
    loading: false,
    error: null,
    redirecting: false,
  });
  const router = useRouter();

  const checkBinRequest = async (bin: string) => {
    try {
      setFormState({ ...formState, error: null, loading: true });
      const { data } = await getCapitalOneBinCheck(bin);
      setFormState({
        ...formState,
        error: null,
        loading: false,
        redirecting: true,
      });
      await delay(1000);
      router.push(data.signup_url);
    } catch (error) {
      setFormState({ ...formState, loading: false, error });
    }
  };

  return (
    <Layout>
      <Head>
        <title>{formatTitle("Vinous | Capital One Subscription Offer")}</title>
      </Head>
      <Header></Header>

      <div className="flex justify-center items-center md:container">
        <form
          className="w-full"
          onSubmit={async (e) => {
            e.preventDefault();
            await checkBinRequest(bin);
          }}
        >
          <div className="flex flex-col justify-center items-center my-24">
            <label
              className="block text-gray-500 font-bold md:text-right m-1"
              htmlFor="inline-full-name"
            >
              Please enter the first 6 digits of your Capital One credit or debit
              card to sign up for your complimentary 6 months Vinous Premium subscription.
            </label>
            <input
              className="bg-gray-200 appearance-none m-4 border-2 border-gray-200 rounded py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-red-500"
              id="inline-full-name"
              type="text"
              value={bin}
              onChange={(e) => setBin(e.target.value)}
            />
            {formState.error && <p>Invalid Credit Card, please try again.</p>}
            {formState.redirecting ? (
              <p>Success! Wait a moment...</p>
            ) : (
              <button
                className={`shadow bg-red m-4 hover:bg-red focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded ${
                  (formState.loading || formState.redirecting) &&
                  "opacity-50 cursor-not-allowed"
                }`}
                type="submit"
                value="submit"
              >
                {formState.loading ? "Checking BIN..." : "Submit"}
              </button>
            )}
          </div>
        </form>
      </div>
    </Layout>
  );
}
